export type GroupButtonSizes = 'small' | 'medium' | 'large';

export const GROUP_BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;
